import { Modal } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { FileInput } from "../Inputs/Inputs.tsx";

import "../koohrokhi.scss";

import { useEffect, useMemo, useState } from "react";
import sendRequest from "hooks/useAxios.jsx";
import { showSwalError, showSwalSuccess } from "utils/swal.js";
import { useContext } from "react";
import TrackContext from "context/TracksContext.jsx";
import { last } from "lodash";
import LoaderCustom from "utils/LoaderCustom.jsx";
// import User from "../../../hooks/useAuthentication.jsx"

export default function AddEditTrack({ show, setShow, type, tags }) {
  const [isLoader, setIsLoader] = useState(false);
  const { valueEditModal, setUpdateList, updateList, setvalueEditModal } =
    useContext(TrackContext);
  const [previewImage, setPreviewImage] = useState(null);
  const [selectedOption, setSelectedOption] = useState([]);
  const [audioCount, setAudioCount] = useState(0);
  const [audioFiles, setAudioFiles] = useState([]);
  const [data, setData] = useState({
    title: "",
    description: "",
    tags: "",
    cover: "",
    audio: "",
  });
  const dataHandler = (object) => {
    setData((prev) => {
      return { ...prev, ...object };
    });
  };
  let modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],

      [{ color: [] }],
      [{ header: "1" }, { header: "2" }, { font: [] }],
    ],
  };

  let formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  let options = [];
  if (tags) {
    options = tags.map((val) => {
      return { value: val.title, label: val.title, id: val.id };
    });
  }

  const handleFileChangeCover = (e) => {
    const selectedFile = e.target.files[0];
    dataHandler({ cover: selectedFile });
  };

  const handleFileChangeSound = (e) => {
    const selectedFile = e.target.files[0];
    setAudioFiles([...audioFiles, selectedFile]);
    setAudioCount((prev) => prev + 1);
    // console.log("selectedFile", selectedFile);
    // console.log("audioFiles", audioFiles);
    // console.log("audioCount", audioCount);
  };

  const handleCreateOption = (inputValue) => {
    const newOption = {
      value: inputValue.toLowerCase(),
      label: inputValue,
    };
    setSelectedOption([...selectedOption, newOption]);
    sendRequest("audio/Insert_tags", { title: newOption.value }).then((res) => {
      setUpdateList(!updateList);
    });
    // You can also add the new option to your options list
    // selectedOption[selectedOption.length - 1] = last(options);
  };
  useMemo(
    () => {
      if (valueEditModal !== "") {
        valueEditModal.tags.map((val) => {
          setSelectedOption((prev) => [
            ...prev,
            {
              value: val.title.toLowerCase(),
              label: val.title,
              id: val.id,
            },
          ]);
        })
        dataHandler({ tags: valueEditModal.tags.map((val) => val.id).join(",") });
      }
    },
    [valueEditModal]
  );

  useEffect(() => {
    dataHandler({ audio: audioFiles });
  }, [audioFiles]);

  useEffect(() => {
    if (selectedOption.length !== 0) {
      selectedOption[selectedOption.length - 1] = last(options);
      dataHandler({ tags: selectedOption.map((val) => val.id).join(",") });
    }
  }, [tags]);

  const onClickHandlerSubmit = () => {
    setIsLoader(true);
    let d;
    if (type === "add") {
      if (
        data.title !== "" &&
        // data.description !== "" &&
        data.tags !== "" &&
        audioCount !== 0
      ) {
        d = {
          title: data.title,
          description: data.description !== "" ? data.description : "",
          tags: data.tags,
          pic: data.cover,
          audioCount: audioCount,
        };
        for (let i = 0; i < audioCount; i++) {
          d[`file${i + 1}`] = audioFiles[i];
        }
        sendRequest("audio/add_track", d).then((res) => {
          if (res.data.status === 1) {
            showSwalSuccess("ترک با موفقیت اضافه شد.");
            setSelectedOption([]);
            dataHandler({
              title: "",
              description: "",
              tags: "",
              cover: "",
              audio: "",
            });
            setAudioFiles([]);
            setAudioCount(0);
            setUpdateList(!updateList);
            setTimeout(() => {
              setShow(false);
            }, 2000);
            setIsLoader(false);
          } else if (res.data.status === -1) {
            showSwalError(
              "ورودی ها را به درستی وارد کنید. عنوان، تگ و صدا باید وارد شود."
            );
            setIsLoader(false);
          } else if (res.data.status === -2 || res.data.status === -3) {
            showSwalError("مشکلی در افزودن ترک وجود دارد، دوباره تلاش کنید.");
            setIsLoader(false);
          }
        });
      } else {
        showSwalError(
          "ورودی ها را به درستی وارد کنید. عنوان، تگ و صدا باید وارد شود."
        );
        setIsLoader(false);
      }
    } else {
      d = {
        audioId: valueEditModal.id,
        title: data.title !== "" ? data.title : valueEditModal.title,
        description:
          data.description !== ""
            ? data.description
            : valueEditModal.description,
        tags: data.tags !== "" ? data.tags : "",
        pic:
          data.cover !== ""
            ? data.cover
            : valueEditModal.fileId != 0
              ? valueEditModal.file.path
              : "",
      };
      console.log("d", d);
      for (let i = 0; i < audioCount; i++) {
        d[`file${i + 1}`] = audioFiles[i];
      }
      if (audioCount !== 0) {
        d["audioCount"] = audioCount;
      }
      sendRequest("audio/edit_track", d).then((res) => {
        if (res.data.status === 1) {
          showSwalSuccess("ترک با موفقیت ویرایش شد.");
          setSelectedOption([]);
          dataHandler({
            title: "",
            description: "",
            tags: "",
            cover: "",
            audio: "",
          });
          setUpdateList(!updateList);
          setTimeout(() => {
            setShow(false);
          }, 2000);
          setIsLoader(false);
        } else if (res.data.status === -1) {
          showSwalError(
            "ورودی ها را به درستی وارد کنید. عنوان، تگ و صدا باید وارد شود."
          );
          setIsLoader(false);
        } else if (res.data.status === -2 || res.data.status === -3) {
          showSwalError("مشکلی در ویرایش ترک وجود دارد، دوباره تلاش کنید.");
          setIsLoader(false);
        }
      });
    }
  };
  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
        setSelectedOption([]);
        setvalueEditModal("");
      }}
      className="add-edit-track"
      size="lg"
      fullscreen="lg-down"
    >
      <Modal.Header closeButton>
        {type == "add" ? "افزودن ترک" : "ویرایش ترک"}
      </Modal.Header>
      <Modal.Body>
        {isLoader ? <LoaderCustom></LoaderCustom> : ""}
        <div className="mt-1">
          <label className="custom-label">عنوان:</label>
          <input
            className="form-control"
            onChange={(e) => {
              dataHandler({ title: e.target.value });
            }}
            value={valueEditModal !== "" ? valueEditModal.title : data.title}
            defaultValue={valueEditModal !== "" ? valueEditModal.title : ""}
          />
        </div>

        <div className="mt-1">
          <label className="custom-label">تگها:</label>
          <CreatableSelect
            isMulti={true}
            options={options}
            value={selectedOption}
            onChange={(e) => {
              setSelectedOption(e);
              dataHandler({ tags: e.map((val) => val.id).join(",") });
            }}
            onCreateOption={handleCreateOption}
          />
        </div>
        <div className="d-flex">
          <div className="mt-1 flex-grow-1 me-1">
            <FileInput
              id="1"
              label="کاور:"
              onChangeFunc={handleFileChangeCover}
            />
          </div>
          <div className="mt-1 flex-grow-1 ms-1">
            <FileInput
              id="2"
              label="صدا:"
              onChangeFunc={handleFileChangeSound}
              accept="audio/*"
            />
          </div>
        </div>
        <div className="mt-1">
          <label className="custom-label">توضیحات:</label>
          <div dir="ltr">
            <ReactQuill
              theme="snow"
              modules={modules}
              formats={formats}
              onChange={(e) => dataHandler({ description: e })}
              defaultValue={valueEditModal.description}
            ></ReactQuill>
          </div>
          {/* <textarea
            className="form-control"
            onChange={(e) => {
              dataHandler({ description: e.target.value });
            }}
          /> */}
        </div>
        <div className="d-flex my-2">
          <button
            className="btn bg-danger text-light ms-auto"
            onClick={onClickHandlerSubmit}
          >
            ذخیره
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
